import { MultiSelectAutoCompleteComponent } from './multi-select-auto-complete.component';
import { NgModule } from '@angular/core';
import { CommonModule, SlicePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MultiSelectComponent } from './multiselect.component';
import { ListFilterPipe } from './list-filter.pipe';
import { AclNgxModule } from '@amobee/acl-ngx';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  imports: [CommonModule, DirectivesModule, FormsModule, AclNgxModule],
  declarations: [MultiSelectComponent, MultiSelectAutoCompleteComponent, ListFilterPipe],
  providers: [ListFilterPipe, SlicePipe],
  exports: [MultiSelectComponent, MultiSelectAutoCompleteComponent]
})

export class NgMultiSelectDropDownModule { }
